import { render, staticRenderFns } from "./ParchmentDeliveryList.vue?vue&type=template&id=4dc4e539&scoped=true"
import script from "./ParchmentDeliveryList.vue?vue&type=script&lang=js"
export * from "./ParchmentDeliveryList.vue?vue&type=script&lang=js"
import style0 from "./ParchmentDeliveryList.vue?vue&type=style&index=0&id=4dc4e539&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc4e539",
  null
  
)

export default component.exports